export type PlayChromeState = {
  hasCircuit: boolean;
  circuitCells?: number;
  raceStarted: boolean;
  raceFinished: boolean;
};

type PlayPhase = 'circuit' | 'prepare' | 'race' | 'results';

let rootEl: HTMLElement | null = null;
let statusEl: HTMLElement | null = null;

function phaseFromState(state: PlayChromeState): PlayPhase {
  if (state.raceFinished) return 'results';
  if (state.raceStarted) return 'race';
  if (state.hasCircuit) return 'prepare';
  return 'circuit';
}

function statusText(state: PlayChromeState, phase: PlayPhase): string {
  if (phase === 'results') return 'Manche terminée — relancez ou consultez le classement';
  if (phase === 'race') return 'Course en cours — lancez le dé quand c’est votre tour';
  if (phase === 'prepare') {
    const cells = state.circuitCells;
    return cells
      ? `Plateau prêt (${cells} cases) — complétez les étapes de préparation dans le panneau Session`
      : 'Complétez les étapes de préparation dans le panneau Session';
  }
  return 'Choisissez un circuit enregistré (ou créez-en un dans Circuits)';
}

export function mountPlayChrome(gameView: HTMLElement): void {
  if (gameView.querySelector('.play-chrome')) return;

  const chrome = document.createElement('header');
  chrome.className = 'play-chrome';
  chrome.innerHTML = `
    <div class="play-chrome-intro">
      <p class="play-chrome-eyebrow">MultiRX · Mode course</p>
      <h1 class="play-chrome-title">Jouer</h1>
    </div>
    <p class="play-status" id="play-status" role="status"></p>
  `;

  gameView.insertBefore(chrome, gameView.firstChild);
  rootEl = chrome;
  statusEl = chrome.querySelector('#play-status');

  syncPlayChrome({ hasCircuit: false, raceStarted: false, raceFinished: false });
}

export function syncPlayChrome(state: PlayChromeState): void {
  const phase = phaseFromState(state);
  if (statusEl) statusEl.textContent = statusText(state, phase);

  rootEl?.classList.toggle('play-chrome--racing', phase === 'race');
  rootEl?.classList.toggle('play-chrome--done', phase === 'results');
}
